<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card class="box-card">
          <div slot="header" class="clearfix flex justify-between">
            <span>{{ $t('systemGoldSetting.title') }}</span>
            <div class="card-header-right">
              <!-- <el-button type="primary" size="small" @click="openAddSystemGoldSettingModal">
                <i class="el-icon-plus"></i>
                {{ $t('systemGoldSetting.addButton') }}
              </el-button> -->
            </div>
          </div>

          <el-table
            :data="systemGoldSettingManageInfo.systemGoldSettings"
            style="width: 100%"
            border
            stripe>
            <el-table-column
              prop="settingId"
              :label="$t('systemGoldSetting.settingId')"
              align="center"
              width="120">
            </el-table-column>
            <el-table-column
              prop="goldName"
              :label="$t('systemGoldSetting.goldName')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="goldType"
              :label="$t('systemGoldSetting.goldType')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="buyPrice"
              :label="$t('systemGoldSetting.buyPrice')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="usePrice"
              :label="$t('systemGoldSetting.usePrice')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="validity"
              :label="$t('systemGoldSetting.validity')"
              align="center">
            </el-table-column>
            <el-table-column
              prop="state"
              :label="$t('systemGoldSetting.state')"
              align="center">
            </el-table-column>
            <el-table-column
              :label="$t('systemGoldSetting.operation')"
              align="center"
              width="150">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button
                    size="mini"
                    @click="openEditSystemGoldSettingModel(scope.row)">
                    {{ $t('systemGoldSetting.editButton') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="systemGoldSettingManageInfo.conditions.page"
            :page-size="DEFAULT_ROWS"
            layout="total, prev, pager, next"
            :total="systemGoldSettingManageInfo.total"
            class="pagination">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <edit-system-gold-setting ref="editSystemGoldSetting"></edit-system-gold-setting>
  </div>
</template>

<script>
import { querySystemGoldSetting } from '@/api/admin/systemGoldSettingApi'
import EditSystemGoldSetting from '@/components/admin/systemGoldSettingManage/editSystemGoldSetting'

export default {
  name: 'SystemGoldSettingManage',
  components: {
    EditSystemGoldSetting
  },
  data() {
    return {
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      systemGoldSettingManageInfo: {
        systemGoldSettings: [],
        total: 0,
        records: 1,
        moreCondition: false,
        settingId: '',
        conditions: {
          title: '',
          page: 1,
          row: 10
        }
      }
    }
  },
  created() {
    this.listSystemGoldSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
  },
  methods: {
    listSystemGoldSettings(page, rows) {
      this.systemGoldSettingManageInfo.conditions.page = page
      this.systemGoldSettingManageInfo.conditions.row = rows
      
      querySystemGoldSetting(this.systemGoldSettingManageInfo.conditions)
        .then(response => {
          const data = response.data
          this.systemGoldSettingManageInfo.total = data.total
          this.systemGoldSettingManageInfo.records = data.records
          this.systemGoldSettingManageInfo.systemGoldSettings = data.data
        })
        .catch(error => {
          console.error('请求失败:', error)
        })
    },
    handleCurrentChange(currentPage) {
      this.listSystemGoldSettings(currentPage, this.DEFAULT_ROWS)
    },
    openEditSystemGoldSettingModel(systemGoldSetting) {
      this.$refs.editSystemGoldSetting.open(systemGoldSetting)
    },
    querySystemGoldSettingMethod() {
      this.listSystemGoldSettings(this.DEFAULT_PAGE, this.DEFAULT_ROWS)
    },
    moreCondition() {
      console.log(this.systemGoldSettingManageInfo.moreCondition)
      this.systemGoldSettingManageInfo.moreCondition = !this.systemGoldSettingManageInfo.moreCondition
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
.card-header-right {
  float: right;
  padding: 3px 0;
}
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>